import { ChannelType } from '@faceup/utils'
import { type FragmentType, getFragmentData, graphql } from '../../../../../__generated__'
import { useClient } from '../../../../../App/ClientProvider'
import { getHomepageRouteCallback } from '../../../../../utils/urls'
import { SimpleHeaderContent } from '../../../../Header/SimpleHeaderContent'
import { PartnerInstitutionLogo } from './PartnerInstitutionLogo'

const fragments = {
  HeaderSimple_reportSource: graphql(`
    fragment HeaderSimple_reportSource on PublicReportSource {
      id
      languages
      sourceType
      defaultLanguage
      pages(language: $language) {
        ... on Page {
          id
        }
      }
      ...PartnerInstitutionLogo_reportSource
    }
  `),
}

type HeaderSimpleProps = {
  reportSource: FragmentType<typeof fragments.HeaderSimple_reportSource>
}

export const HeaderSimple = ({ reportSource: _reportSource }: HeaderSimpleProps) => {
  const reportSource = getFragmentData(fragments.HeaderSimple_reportSource, _reportSource)
  const isHiddenBackButton = reportSource.sourceType === ChannelType.AutomatedHotline
  const { client } = useClient()
  const isApp = client === 'app'
  const homepageLinkCallback = getHomepageRouteCallback(reportSource.pages)

  return (
    <SimpleHeaderContent
      isApp={isApp}
      isHiddenBackButton={isHiddenBackButton}
      homepageLinkCallback={homepageLinkCallback}
      logoSlot={<PartnerInstitutionLogo reportSource={reportSource} />}
      languages={reportSource.languages ?? []}
      defaultLanguage={reportSource.defaultLanguage}
    />
  )
}
